import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_account/submit-ticket")({
  beforeLoad: () => {
    throw redirect({ to: "/help" });
  },
});
